// extracted by mini-css-extract-plugin
export default {"cashbackTableWrap":"styles_cashbackTableWrap__UVmHe","cashbackTableBody":"styles_cashbackTableBody__TQqQZ"};